import React from "react"
import { motion } from "framer-motion"
import { FaQuoteLeft, FaStar } from "react-icons/fa"
import { testimonials } from "@/services/start/getTestimonials.js"


const TestimonialCard = ({ testimonial, index }) => {
  return (
    <motion.div
      className="bg-white p-8 rounded-xl shadow-lg relative overflow-hidden"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.2 }}
    >
      <FaQuoteLeft className="text-[var(--navy-blue-light)] opacity-25 text-6xl absolute top-4 left-4" />
      <div className="relative z-10">
        <p className="text-gray-700 mb-6 italic">"{testimonial.text}"</p>
        <div className="flex items-center justify-between">
          <div>
            <div className="font-semibold text-lg text-gray-800">{testimonial.name}</div>
            <div className="text-sm text-[var(--gold-dark)] ">{testimonial.role}</div>
          </div>
          <div className="flex text-yellow-400">
            {[...Array(5)].map((_, i) => (
              <FaStar key={i} className={i < testimonial.rating ? "text-yellow-400" : "text-gray-300"} />
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  )
}

function Testimonials() {
  return (
    <section className="py-20 bg-transparent overflow-hidden">
      <div className="container mx-auto px-4 relative">
        <motion.div
          className="absolute top-0 left-0 w-full h-full"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <svg className="absolute top-0 left-0 w-32 h-32 text-[var(--navy-blue-light)] opacity-20" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M44.9,-76.8C59.7,-69.8,74,-59.5,83.4,-45.6C92.8,-31.7,97.3,-14.2,95.9,2.8C94.5,19.8,87.2,36.3,76.6,50.1C66,63.8,52,74.8,36.7,79.8C21.4,84.8,4.8,83.8,-12.1,80.5C-28.9,77.2,-46,71.6,-60.5,61.5C-75.1,51.4,-87.1,36.8,-92.2,20.1C-97.3,3.3,-95.5,-15.6,-88.7,-32.2C-81.9,-48.8,-70.1,-63.1,-55.3,-70.1C-40.5,-77.1,-22.7,-76.8,-5.2,-69.1C12.3,-61.5,30.1,-83.8,44.9,-76.8Z" transform="translate(100 100)" />
          </svg>
          <svg className="absolute bottom-0 right-0 w-48 h-48 text-[var(--navy-blue-light)] opacity-20" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M38.9,-65.7C49.8,-57.8,57.8,-46.3,65.2,-33.6C72.6,-20.9,79.4,-7,78.6,6.5C77.8,20,69.4,33.1,59.7,44.3C50,55.5,39,64.8,26.1,70.3C13.2,75.8,-1.7,77.5,-16.7,75.5C-31.7,73.5,-46.8,67.7,-57.7,57.4C-68.6,47.1,-75.3,32.3,-79.1,16.6C-82.9,0.9,-83.8,-15.7,-78.2,-29.1C-72.6,-42.5,-60.4,-52.7,-47,-61.1C-33.6,-69.5,-19,-76,-3.8,-70.5C11.5,-65,28,-73.6,38.9,-65.7Z" transform="translate(100 100)" />
          </svg>
        </motion.div>
        <div className="relative z-10">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-4xl font-bold mb-4 text-gray-800">Lo que dicen nuestros usuarios</h2>
            <div className="w-24 h-1 bg-[var(--gold)] mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Descubre cómo nuestra plataforma está transformando la forma en que clientes y abogados se conectan y colaboran.
            </p>
          </motion.div>
          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <TestimonialCard key={index} testimonial={testimonial} index={index} />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Testimonials
